import {Link} from "react-router-dom";

export default function HelpArticlesAccount() {
    return (
        <div className="selfcare-page-content selfcare-page-content--wide">
            <div className="selfcare-page-summary">
                <h2 className="heading heading--medium">Kom godt i gang med dit abonnement</h2>
                <p>Tjek vores guides og få det meste ud af dit abonnement.</p>
            </div>
            <div className="selfcare-help-articles">
                <Link to="/hjaelp/mit-abonnement/mit-hiper">
                    Introduktion til Mit Hiper
                </Link>
                <Link to="/hjaelp/regning-og-betaling/forstaa-din-regning">
                    Alt du skal vide om din regning
                </Link>
                <Link to="/hjaelp/bestilling/ny-teknikertid">
                    Sådan ændrer du din teknikertid
                </Link>
                <Link to="/hjaelp/bestilling/ny-online-dato">
                    Ønsker du at ændre datoen for, hvornår dit internet er klar?
                </Link>
            </div>
        </div>
    )
}
